import { ROLE_ADMIN, ROLE_ANALYST, ROLE_CORPORATE } from '../../../constants';

export const TAB_TO_ROLE = {
  admin: ROLE_ADMIN,
  analyst: ROLE_ANALYST,
  corporate: ROLE_CORPORATE,
};

export const getErrorMessage = (err, fallback) =>
  err?.response?.data?.message ||
  err?.message ||
  fallback;
